import { useEffect, useRef } from "react";
import usePlayerUtils from "./usePlayerUtils";

export function useAudioVisualizer() {
    const {
        dataArrayRef,
    } = usePlayerUtils();

    const canvasRef = useRef(null);
    const barValuesRef = useRef([]);

    const getLinearFrequencies = (dataArray, bands = 64) => {
        const linearData = [];
        for (let i = 0; i < bands; i++) {
            const idx = Math.floor(Math.pow(i / bands, 2) * dataArray.length / 6);
            linearData.push(dataArray[idx]);
        }
        return linearData;
    };

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;

        const ctx = canvas.getContext("2d");
        const centerY = canvas.height;
        const bands = 30;
        const rise = 2.5;
        const decay = 0.9;

        if (barValuesRef.current.length !== bands) {
            barValuesRef.current = new Array(bands).fill(0);
        }

        let animationId;
        let lastFrameTime = 0;
        const fpsLimit = 17;

        const draw = (time) => {
            const dataArray = dataArrayRef.current;
            if (!dataArray) return;

            if (time - lastFrameTime < 1000 / fpsLimit) {
                animationId = requestAnimationFrame(draw);
                return;
            }
            lastFrameTime = time;

            ctx.clearRect(0, 0, canvas.width, canvas.height);

            const freqs = getLinearFrequencies(dataArray, bands);
            const barWidth = canvas.width / bands;

            freqs.forEach((value, i) => {
                const target = (value / 130) * centerY;
                const current = barValuesRef.current[i];

                barValuesRef.current[i] =
                    target > current ? current + (target - current) * rise : current * decay;

                const barHeight = (barValuesRef.current[i] / 250) * centerY;

                ctx.fillStyle = `rgb(${barHeight + 10},200,250)`;
                const x = i * barWidth;
                ctx.fillRect(x, centerY - barHeight, barWidth - 1.2, barHeight);
            });

            animationId = requestAnimationFrame(draw);
        };

        draw();

        return () => cancelAnimationFrame(animationId);
    }, [dataArrayRef]);

    return canvasRef;
}
